module.exports = __webpack_public_path__ + "fonts/_VYFx-s824kXq_Ul2BHqYH-_kf6ByYO6CLYdB4HQE-Y.woff2";